export default __webpack_public_path__ + "static/media/kheng-letters2.370dbc3a.jpg";